import { Typography } from '@mui/material';
import { Tooltip } from 'framework/ui/mui-builder';
import { EDITABLE_LIST_CUSTOM, EDITABLE_LIST_FIELD } from 'framework/list';
import { AnchorField, FormattedTextField } from 'framework/ui/field';
import OriginalPlannedDateField from 'domain/projects/newProject/milestones/OriginalPlannedDateField';
import CurrentlyPlannedDateField from 'domain/projects/newProject/milestones/CurrentlyPlannedDateField';
import LinkedMilestonesField from 'domain/projects/newProject/businessOutcomes/LinkedMilestonesField';
import { Milestone } from 'domain/shared/newProject';
import ControlListSection from '../../shared/ControlListSection';

const OutdatedMilestonesSection = ({
  title,
  milestones,
  emptyMessage,
}: {
  title: string;
  milestones: Milestone[];
  emptyMessage: string;
}) => {
  return (
    <ControlListSection
      title={title}
      items={milestones}
      listSource="milestones"
      emptyMessage={emptyMessage}
      getTableCells={() =>
        Promise.resolve([
          {
            type: EDITABLE_LIST_FIELD,
            source: 'alias',
            isEditor: false,
            component: AnchorField,
            componentProps: {
              isInternal: true,
              label: '',
            },
            gridCellProps: {
              size: 0.5,
              sx: { display: 'flex', justifyContent: 'flex-start' },
            },
          },
          {
            type: EDITABLE_LIST_FIELD,
            source: 'title',
            isEditor: false,
            component: FormattedTextField,
            componentProps: {
              label: '',
              format: (str: string) =>
                str && str.length > 60 ? (
                  <Tooltip title={str}>
                    <div>
                      <Typography
                        sx={{
                          display: '-webkit-box',
                          WebkitLineClamp: 1,
                          WebkitBoxOrient: 'vertical',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          lineHeight: 1.2,
                          wordBreak: 'break-word',
                        }}
                      >
                        {str}
                      </Typography>
                    </div>
                  </Tooltip>
                ) : (
                  str
                ),
            },
            gridCellProps: { size: 4.5 },
          },
          {
            type: EDITABLE_LIST_CUSTOM,
            isEditor: false,
            component: OriginalPlannedDateField,
            componentProps: {
              initialPlannedDateSource: 'initialPlannedDate',
              statusSource: 'status',
              label: '',
              color: 'error.main',
            },
            gridCellProps: { size: 2 },
          },
          {
            type: EDITABLE_LIST_CUSTOM,
            component: CurrentlyPlannedDateField,
            componentProps: {
              currentPlannedDateSource: 'currentPlannedDate',
              completionDateSource: 'completionDate',
              rejectionDateSource: 'rejectionDate',
            },
            gridCellProps: { size: 2 },
          },
          {
            type: EDITABLE_LIST_FIELD,
            source: 'businessOutcomes',
            isEditor: false,
            component: LinkedMilestonesField,
            componentProps: { label: '' },
            gridCellProps: {
              size: 1.5,
            },
          },
        ])
      }
    />
  );
};
export default OutdatedMilestonesSection;
